import { useTranslation } from 'react-i18next'

import { Badge } from '@/shared/components/ui/badge'
import { Footer } from '@/shared/components/ui/layout'
import {
	PaginationControlled,
	usePagination,
} from '@/shared/components/ui/pagination-controlled'
import { Spinner } from '@/shared/components/ui/spinner'
import { useLocationQuery } from '@/shared/hooks/useLocationQuery'
import { formatNumber, NumberFormats } from '@/shared/tools/locale'

import { useApprovalPageContext } from './ApprovalPageProvider'

export default function ApprovalPageFooter() {
	const { t } = useTranslation()

	const { data, total, isDataFetching } = useApprovalPageContext()
	const [{ limit = 100, offset = 0 }, setQuery] = useLocationQuery()
	const pagination = usePagination({
		total,
		limit,
		offset,
		onChange: setQuery,
	})

	return (
		<Footer className='h-8 items-center space-x-2 py-3'>
			<PaginationControlled className='m-0 w-auto' pagination={pagination} />
			<Badge size='sm'>
				<div className='inline-flex items-center gap-1 text-xs'>
					<span>{t('app.total')}:</span>
					{isDataFetching ? (
						<Spinner data-testid='total-spinner' />
					) : (
						<>
							<strong data-testid='page-items-flat-count'>
								{formatNumber(data?.length || 0, NumberFormats.Integer)}
							</strong>
							<strong>{t('general_of')}</strong>
							<strong data-testid='total-items-flat-count'>
								{formatNumber(total || 0, NumberFormats.Integer)}
							</strong>
						</>
					)}
				</div>
			</Badge>
		</Footer>
	)
}
